import { render, staticRenderFns } from "./DailyBriefingSignatureRequest.vue?vue&type=template&id=4f702c76&"
import script from "./DailyBriefingSignatureRequest.vue?vue&type=script&lang=js&"
export * from "./DailyBriefingSignatureRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports